import { OptionType } from '../components';

export const getOptionByValue = (value?: string, options?: Nullable<OptionType[]>): OptionType => {
  if (value && options && options.length) {
    return options.find((option) => option.value === value) || { value: '', label: '' };
  }

  return { value: '', label: '' };
};
